import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { collection } from "@/services/api";
import { apiError } from "@/lib/http";

export function useCollection(name, params) {
  const qc = useQueryClient();
  const svc = collection(name);
  const key = ["col", name, params || {}];
  const q = useQuery({ queryKey: key, queryFn: () => svc.list(params) });
  const invalidate = () => {
    qc.invalidateQueries({ queryKey: ["col", name] });
    qc.invalidateQueries({ queryKey: ["summary"] });
  };
  const onError = (e) => toast.error(apiError(e));

  const create = useMutation({ mutationFn: svc.create, onSuccess: invalidate, onError });
  const update = useMutation({ mutationFn: ({ id, ...data }) => svc.update(id, data), onSuccess: invalidate, onError });
  const remove = useMutation({ mutationFn: svc.remove, onSuccess: invalidate, onError });

  return { items: q.data || [], isLoading: q.isLoading, create, update, remove, refetch: q.refetch };
}
